// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.KeywordBenchmark_keyword-benchmark__Khw7D {
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.KeywordBenchmark_keyword-benchmark--results__uL2xR {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  padding: 0 12px;
}
@media only screen and (min-width: 600px) {
  .KeywordBenchmark_keyword-benchmark--results__uL2xR {
    padding: 0 16px;
  }
}
@media only screen and (max-width: 480px) {
  .KeywordBenchmark_keyword-benchmark--results__uL2xR {
    padding: 0 10px;
  }
}

/* ── Centered Content ── */
.KeywordBenchmark_centered-content__NREx3 {
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.KeywordBenchmark_page-header__Dud4h {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  padding: 0 20px;
}
.KeywordBenchmark_page-header__title__7X9nV {
  color: var(--accent-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
}
.KeywordBenchmark_page-header__description__foI7X {
  color: var(--grey-text);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  max-width: 700px;
  margin: 0;
}

/* ── Search Section ── */
.KeywordBenchmark_search-section__4BBXL {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  width: 100%;
}

.KeywordBenchmark_search-row__Kbd4g {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  max-width: 960px;
}

.KeywordBenchmark_search-bar__e897I {
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  padding: 10px 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.25s, border-color 0.25s;
  cursor: text;
}
.KeywordBenchmark_search-bar__e897I:focus-within {
  border-color: rgba(15, 52, 96, 0.25);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04);
}
.KeywordBenchmark_search-bar__icon__b98MT {
  flex-shrink: 0;
  color: #94a3b8;
}
.KeywordBenchmark_search-bar__chip__TNmh8 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #0f3460;
  color: #fff;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  animation: KeywordBenchmark_chipIn__KOom8 0.2s ease-out;
}
.KeywordBenchmark_search-bar__chip-remove__\\+jkGE {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s;
  padding: 0;
}
.KeywordBenchmark_search-bar__chip-remove__\\+jkGE:hover {
  background: rgba(255, 255, 255, 0.45);
}
.KeywordBenchmark_search-bar__input-wrapper__LEG8j {
  position: relative;
  flex: 1 1;
  min-width: 150px;
  display: flex;
  align-items: center;
}
.KeywordBenchmark_search-bar__input__\\+42Us {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 15px;
  color: var(--text-1, #1a1a2e);
  padding: 6px 4px;
}
.KeywordBenchmark_search-bar__input__\\+42Us::placeholder {
  color: transparent;
}
.KeywordBenchmark_search-bar__typewriter__T\\+026 {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  color: #94a3b8;
  pointer-events: none;
  white-space: nowrap;
}
.KeywordBenchmark_search-bar__cursor__s4Sc4 {
  display: inline-block;
  font-weight: 300;
  color: #94a3b8;
  animation: KeywordBenchmark_blink__od2KI 0.8s step-end infinite;
  margin-left: 1px;
}
.KeywordBenchmark_search-bar__e897I {
  /* Suggestions dropdown */
}
.KeywordBenchmark_search-bar__suggestions__98AGT {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  z-index: 100;
  max-height: 260px;
  overflow-y: auto;
  padding: 6px;
  animation: KeywordBenchmark_dropIn__Dv1of 0.15s ease-out;
}
.KeywordBenchmark_search-bar__suggestion-item__e7MQE {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  background: transparent;
  font-size: 14px;
  color: var(--text-1, #1a1a2e);
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.12s;
}
.KeywordBenchmark_search-bar__suggestion-item__e7MQE:hover {
  background: rgba(15, 52, 96, 0.06);
}

/* ── Analyze Button ── */
.KeywordBenchmark_analyze-btn__HSPWP {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 32px;
  border-radius: 14px;
  border: none;
  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s;
  box-shadow: 0 4px 16px rgba(30, 58, 95, 0.2);
  white-space: nowrap;
}
.KeywordBenchmark_analyze-btn__HSPWP:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(30, 58, 95, 0.3);
  filter: brightness(110%);
}
.KeywordBenchmark_analyze-btn__HSPWP:active:not(:disabled) {
  transform: translateY(0);
}
.KeywordBenchmark_analyze-btn__HSPWP:disabled {
  background: #cbd5e1;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}

/* ── Recommended Domains ── */
.KeywordBenchmark_recommended__QObzd {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: 780px;
}
.KeywordBenchmark_recommended__label__6SS4f {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #94a3b8;
}
.KeywordBenchmark_recommended__chips__v7aOO {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.KeywordBenchmark_recommended__chip__DHxol {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}
.KeywordBenchmark_recommended__chip__DHxol:hover {
  border-color: rgba(15, 52, 96, 0.2);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}
.KeywordBenchmark_recommended__chip--selected__mkSSZ {
  background: #0f3460;
  color: #fff;
  border-color: #0f3460;
}
.KeywordBenchmark_recommended__chip--selected__mkSSZ:hover {
  border-color: #0f3460;
  filter: brightness(110%);
}
.KeywordBenchmark_recommended__chip-action__HLB8s {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.6;
}

/* ── Animations ── */
@keyframes KeywordBenchmark_chipIn__KOom8 {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes KeywordBenchmark_dropIn__Dv1of {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes KeywordBenchmark_blink__od2KI {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
/* ── Responsive ── */
@media only screen and (max-width: 900px) {
  .KeywordBenchmark_page-header__title__7X9nV {
    font-size: 24px;
  }
  .KeywordBenchmark_search-bar__e897I {
    border-radius: 14px;
    padding: 8px 12px;
  }
  .KeywordBenchmark_analyze-btn__HSPWP {
    padding: 12px 24px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 600px) {
  .KeywordBenchmark_search-row__Kbd4g {
    flex-direction: column;
  }
  .KeywordBenchmark_search-bar__input-wrapper__LEG8j {
    min-width: 100px;
  }
  .KeywordBenchmark_analyze-btn__HSPWP {
    width: 100%;
    padding: 14px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/KeywordBenchmark.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AAEF;AAAE;EANF;IAOI,eAAA;EAGF;AACF;AADE;EAVF;IAWI,eAAA;EAIF;AACF;;AADA,2BAAA;AACA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAIF;AAFE;EACE,0BAAA;EACA,+DAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAIJ;AADE;EACE,uBAAA;EACA,+DAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAGJ;;AACA,yBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,kBAAA;EACA,yEAAA;EACA,gDAAA;EACA,YAAA;AAEF;AAAE;EACE,oCAAA;EACA,wEAAA;AAEJ;AACE;EACE,cAAA;EACA,cAAA;AACJ;AAEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uDAAA;AAAJ;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,UAAA;AADJ;AAGI;EACE,qCAAA;AADN;AAKE;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;AAJJ;AAMI;EACE,kBAAA;AAJN;AAQE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AANJ;AASE;EACE,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,+DAAA;EACA,gBAAA;AAPJ;AA7FA;EAuGE,yBAAA;AAPF;AAQE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,wDAAA;AANJ;AASE;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AAPJ;AASI;EACE,kCAAA;AAPN;;AAYA,yBAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,4CAAA;EACA,mBAAA;AATF;AAWE;EACE,2BAAA;EACA,4CAAA;EACA,wBAAA;AATJ;AAYE;EACE,wBAAA;AAVJ;AAaE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;;AAeA,8BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAZJ;AAeE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AAbJ;AAgBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,yCAAA;AAdJ;AAgBI;EACE,mCAAA;EACA,0CAAA;EACA,2BAAA;AAdN;AAiBI;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAfN;AAiBM;EACE,qBAAA;EACA,wBAAA;AAfR;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;AAlBJ;;AAsBA,qBAAA;AACA;EACE;IACE,UAAA;IACA,sBAAA;EAnBF;EAsBA;IACE,UAAA;IACA,mBAAA;EApBF;AACF;AAuBA;EACE;IACE,UAAA;IACA,2BAAA;EArBF;EAwBA;IACE,UAAA;IACA,wBAAA;EAtBF;AACF;AAyBA;EACE;IACE,UAAA;EAvBF;EA0BA;IACE,UAAA;EAxBF;AACF;AA2BA,qBAAA;AACA;EAEI;IACE,eAAA;EA1BJ;EA8BA;IACE,mBAAA;IACA,iBAAA;EA5BF;EA+BA;IACE,kBAAA;IACA,eAAA;EA7BF;AACF;AAgCA;EACE;IACE,sBAAA;EA9BF;EAkCE;IACE,gBAAA;EAhCJ;EAoCA;IACE,WAAA;IACA,kBAAA;EAlCF;AACF","sourcesContent":[".keyword-benchmark {\n  width: 100%;\n  min-height: 80vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n}\n\n.keyword-benchmark--results {\n  width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n  padding: 0 12px;\n\n  @media only screen and (min-width: 600px) {\n    padding: 0 16px;\n  }\n\n  @media only screen and (max-width: 480px) {\n    padding: 0 10px;\n  }\n}\n\n/* ── Centered Content ── */\n.centered-content {\n  width: 100%;\n  max-width: 960px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n}\n\n.page-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  text-align: center;\n  padding: 0 20px;\n\n  &__title {\n    color: var(--accent-color);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.3;\n    margin: 0;\n  }\n\n  &__description {\n    color: var(--grey-text);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.6;\n    max-width: 700px;\n    margin: 0;\n  }\n}\n\n/* ── Search Section ── */\n.search-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 28px;\n  width: 100%;\n}\n\n.search-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  max-width: 960px;\n}\n\n.search-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 16px;\n  padding: 10px 16px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);\n  transition: box-shadow 0.25s, border-color 0.25s;\n  cursor: text;\n\n  &:focus-within {\n    border-color: rgba(15, 52, 96, 0.25);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04);\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    color: #94a3b8;\n  }\n\n  &__chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 12px;\n    background: #0f3460;\n    color: #fff;\n    border-radius: 20px;\n    font-size: 13px;\n    font-weight: 600;\n    white-space: nowrap;\n    animation: chipIn 0.2s ease-out;\n  }\n\n  &__chip-remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    border: none;\n    background: rgba(255, 255, 255, 0.25);\n    color: #fff;\n    border-radius: 50%;\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n    cursor: pointer;\n    transition: background 0.15s;\n    padding: 0;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.45);\n    }\n  }\n\n  &__input-wrapper {\n    position: relative;\n    flex: 1;\n    min-width: 150px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__input {\n    width: 100%;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-size: 15px;\n    color: var(--text-1, #1a1a2e);\n    padding: 6px 4px;\n\n    &::placeholder {\n      color: transparent;\n    }\n  }\n\n  &__typewriter {\n    position: absolute;\n    left: 4px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 15px;\n    color: #94a3b8;\n    pointer-events: none;\n    white-space: nowrap;\n  }\n\n  &__cursor {\n    display: inline-block;\n    font-weight: 300;\n    color: #94a3b8;\n    animation: blink 0.8s step-end infinite;\n    margin-left: 1px;\n  }\n\n  /* Suggestions dropdown */\n  &__suggestions {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    background: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 14px;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n    z-index: 100;\n    max-height: 260px;\n    overflow-y: auto;\n    padding: 6px;\n    animation: dropIn 0.15s ease-out;\n  }\n\n  &__suggestion-item {\n    display: block;\n    width: 100%;\n    text-align: left;\n    padding: 10px 14px;\n    border: none;\n    background: transparent;\n    font-size: 14px;\n    color: var(--text-1, #1a1a2e);\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.12s;\n\n    &:hover {\n      background: rgba(15, 52, 96, 0.06);\n    }\n  }\n}\n\n/* ── Analyze Button ── */\n.analyze-btn {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 14px 32px;\n  border-radius: 14px;\n  border: none;\n  background: linear-gradient(135deg, #1e3a5f 0%, #0f3460 100%);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.25s;\n  box-shadow: 0 4px 16px rgba(30, 58, 95, 0.2);\n  white-space: nowrap;\n\n  &:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(30, 58, 95, 0.3);\n    filter: brightness(110%);\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    background: #cbd5e1;\n    color: #94a3b8;\n    cursor: not-allowed;\n    box-shadow: none;\n  }\n}\n\n/* ── Recommended Domains ── */\n.recommended {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  max-width: 780px;\n\n  &__label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 2.5px;\n    text-transform: uppercase;\n    color: #94a3b8;\n  }\n\n  &__chips {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n  }\n\n  &__chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 16px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    background: #fff;\n    border-radius: 24px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--text-1, #1a1a2e);\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);\n\n    &:hover {\n      border-color: rgba(15, 52, 96, 0.2);\n      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.06);\n      transform: translateY(-1px);\n    }\n\n    &--selected {\n      background: #0f3460;\n      color: #fff;\n      border-color: #0f3460;\n\n      &:hover {\n        border-color: #0f3460;\n        filter: brightness(110%);\n      }\n    }\n  }\n\n  &__chip-action {\n    font-size: 14px;\n    font-weight: 600;\n    opacity: 0.6;\n  }\n}\n\n/* ── Animations ── */\n@keyframes chipIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes dropIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n}\n\n/* ── Responsive ── */\n@media only screen and (max-width: 900px) {\n  .page-header {\n    &__title {\n      font-size: 24px;\n    }\n  }\n\n  .search-bar {\n    border-radius: 14px;\n    padding: 8px 12px;\n  }\n\n  .analyze-btn {\n    padding: 12px 24px;\n    font-size: 14px;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .search-row {\n    flex-direction: column;\n  }\n\n  .search-bar {\n    &__input-wrapper {\n      min-width: 100px;\n    }\n  }\n\n  .analyze-btn {\n    width: 100%;\n    padding: 14px 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keyword-benchmark": `KeywordBenchmark_keyword-benchmark__Khw7D`,
	"keyword-benchmark--results": `KeywordBenchmark_keyword-benchmark--results__uL2xR`,
	"centered-content": `KeywordBenchmark_centered-content__NREx3`,
	"page-header": `KeywordBenchmark_page-header__Dud4h`,
	"page-header__title": `KeywordBenchmark_page-header__title__7X9nV`,
	"page-header__description": `KeywordBenchmark_page-header__description__foI7X`,
	"search-section": `KeywordBenchmark_search-section__4BBXL`,
	"search-row": `KeywordBenchmark_search-row__Kbd4g`,
	"search-bar": `KeywordBenchmark_search-bar__e897I`,
	"search-bar__icon": `KeywordBenchmark_search-bar__icon__b98MT`,
	"search-bar__chip": `KeywordBenchmark_search-bar__chip__TNmh8`,
	"chipIn": `KeywordBenchmark_chipIn__KOom8`,
	"search-bar__chip-remove": `KeywordBenchmark_search-bar__chip-remove__+jkGE`,
	"search-bar__input-wrapper": `KeywordBenchmark_search-bar__input-wrapper__LEG8j`,
	"search-bar__input": `KeywordBenchmark_search-bar__input__+42Us`,
	"search-bar__typewriter": `KeywordBenchmark_search-bar__typewriter__T+026`,
	"search-bar__cursor": `KeywordBenchmark_search-bar__cursor__s4Sc4`,
	"blink": `KeywordBenchmark_blink__od2KI`,
	"search-bar__suggestions": `KeywordBenchmark_search-bar__suggestions__98AGT`,
	"dropIn": `KeywordBenchmark_dropIn__Dv1of`,
	"search-bar__suggestion-item": `KeywordBenchmark_search-bar__suggestion-item__e7MQE`,
	"analyze-btn": `KeywordBenchmark_analyze-btn__HSPWP`,
	"recommended": `KeywordBenchmark_recommended__QObzd`,
	"recommended__label": `KeywordBenchmark_recommended__label__6SS4f`,
	"recommended__chips": `KeywordBenchmark_recommended__chips__v7aOO`,
	"recommended__chip": `KeywordBenchmark_recommended__chip__DHxol`,
	"recommended__chip--selected": `KeywordBenchmark_recommended__chip--selected__mkSSZ`,
	"recommended__chip-action": `KeywordBenchmark_recommended__chip-action__HLB8s`
};
export default ___CSS_LOADER_EXPORT___;
